import i18n from '@/api/i18n/i18n';

const actionDict = {
  50: i18n.t('pages.actionDict.connected'),
  51: i18n.t('pages.actionDict.disconnected'),
};

export const action = (val) => actionDict[val];
